import { memo, useRef } from 'react';
import { TwitchPlayer, TwitchPlayerInstance } from 'react-twitch-embed';
import { toTwitchChannel } from 'src/util/toTwitchChannel';

export type TwitchPlayerBluMintProps = {
  activeMediaUrl: string;
};

export const TwitchPlayerBluMint = memo(function TwitchPlayerBluMint({
  activeMediaUrl,
}: TwitchPlayerBluMintProps) {
  const twitchPlayer = useRef<TwitchPlayerInstance>();
  const setTwitchRef = (player: TwitchPlayerInstance) => {
    twitchPlayer.current = player;
  };

  return (
    <div>
      <TwitchPlayer
        channel={toTwitchChannel('https://www.twitch.tv/', activeMediaUrl)}
        autoplay
        muted
        onReady={setTwitchRef}
        height="100%"
        width="100%"
        style={{
          position: 'absolute',
          top: 0,
          bottom: 0,
          right: 0,
          left: 0,
        }}
      />
    </div>
  );
});
